export enum MASTER_CODE_TYPE {
  PROFESSION_ROLE_CODE = 'BM0001',
  SYSTEM_ROLE_CODE = 'BM0002',
  PROJECT_ROLE_CODE = 'BM0003',
  JOB_TYPE_CODE = 'BM0005',
  ROLE_CODE = 'BM0004',
  PURPOSE = 'BM0007',
  ITEM_TYPE_1 = 'BM0008',
  ITEM_TYPE_2 = 'BM0009',
  ITEM_TYPE_3 = 'BM0010',
  MANAGEMENT = 'BM0011',
  DEPARTMENT = 'BM0012',
  PROCESS_STATUS = 'BM0016',
  TOPIC_PRIORITY = 'BM0020',
  PHASE = 'BM0024',
  STATUS_CODE = 'BM0022',
  ELEMENT_TYPE = 'BM0025',
  TRIAGE_TYPE = 'BM0026',
  CONSTRUCTION_TYPE = 'BM0028',
  COMPONENT_CLASSIFICATION = 'BM0029',
  PILLARS_OF_HIERARCHY = 'BM0030',
  QUANTITY_PRICING = 'BM0032',
  RECIPIENT_GROUP = 'BM0034',
  TAK_QS = 'BM0035',
  ESTIMATE = 'BM0036',
  REQUEST_TYPE = 'BM0037',
  CALENDAR_YEAR_RANGE = 'BM0046',
  BRANCH_CODE = 'BM0048',
  AUTOCHECK_FLG = 'BM0050',
  SECTION = 'BM0052',
  FIREPROOF_COVERAGE = 'BM0053',
  LABEL = 'BM0054',
  TOPIC_FILE_TYPE = 'BM0055',
  STEELMAKING_TYPE = 'BM0056',
  STARTING_POINT_CONNECTION_CONDITIONS = 'BM0057',
  FIELD_WELD_TYPE = 'BM0058',
  ANCHOR_BOLTS = 'BM0059',
  BASE_PL_STANDARD = 'BM0060',
  BASE_PL_SPEC = 'BM0061',
  RIB_PL_STANDARD = 'BM0062',
  COLUMN_STEEL_SHAPE = 'BM0063',
  HIERARCHY = 'BM0064',
  ATTACHED_COLUMN_SURFACE = 'BM0065',
  CONNECTED_MEMBER = 'BM0066',
  RC_SLUB_EXISTENCE = 'BM0067',
  STRUCTURE_SRC = 'BM0068',
  STARTING_POINT_CONNECTION_MEMBER = 'BM0070',
  STARTING_POINT_FILLER_PL_REQUIRED = 'BM0071',
  BRACE_COMPONENT = 'BM0074',
  BRACE_PIPE_CONNECTION_POSITION = 'BM0075',
  JOINT = 'BV0001', // 節 (joint/node)
  FIREPROOF_SCOPE = 'BV0002', // 耐火被覆の範囲
  RIB_OR_START_FILLER_REQ = 'BV0003', // ベースPL用リブPL要否 / 始点フィラーPL要否
  INOUT = 'BV0004', // 屋内外種別 (indoor/outdoor)
  STEELMAKING = 'BV0005', // 製鋼種別（高炉/電炉）
  CONNECTION = 'BV0006', // 接合条件/接続方法 (start/end) ※ as requested
  FIELD_WELD_JOINT = 'BV0007', // 現場溶接継手形式（節用）
  ANCHOR_BOLT_STD = 'BV0008', // アンカーボルト（仕様） //v1.13: BV002D001 reassigned this code from 規格 to 仕様
  ANCHOR_BOLT_STANDARD = 'BV0026', // アンカーボルト（規格） //v1.13
  BASE_PL_STD = 'BV0009', // ベースPLの規格
  PL_SPEC = 'BV0010', // ベースPL（仕様）/リブPL（仕様）
  RIB_PL_STD = 'BV0011', // リブPL（規格）
  COLUMN_SECTION = 'BV0012', // 柱鋼材の形状
  LEVEL = 'BV0013', // 階層
  COLUMN_FACE = 'BV0014', // 取り付く柱鋼材の面（start/end含む）
  MEMBER_AFTER_CONNECT = 'BV0015', // 接続後の部材
  RC_SLAB = 'BV0016', // RCスラブの有無
  SRC_STRUCTURE = 'BV0017', // 構造（SRC該当）
  BEAM_POSITION = 'BV0018', // 梁の位置（開口部/内部）
  CONNECT_TO_PART = 'BV0019', // 接続先の部位部材（start/end）
  START_END_FILLER_REQ = 'BV0020', // 始点/終点 フィラーPL要否
  START_END_CONNECT_METHOD = 'BV0021', // 始点/終点 部材間の接続方法
  CONNECT_TO_PART_2 = 'BV0022', // 接続先の部位部材（start/end）(duplicate id group)
  BRACE_STEEL = 'BV0023', // ブレースの鋼材
  BRACE_CONNECT_POS = 'BV0024',
  STEELMAKING_SECONDARY = 'BV0025', // 製鋼種別（高炉材/電炉材）小梁情報
  BRACKET_BEAM_SHAPE = 'BM0033', // 形状（部材区分=ブラケット/大梁/小梁の場合） //v1.13
}

export const professionToItemCodeType: Record<string, MASTER_CODE_TYPE> = {
  '001': MASTER_CODE_TYPE.ITEM_TYPE_1,
  '002': MASTER_CODE_TYPE.ITEM_TYPE_2,
  '003': MASTER_CODE_TYPE.ITEM_TYPE_3,
};

export const ruleIdsIfcOrType: string[] = [
  'R0001',
  'R0005',
  'R0006',
  'R0007',
  'R0008',
  'R0009',
  'R0010',
  'R0012',
  'R0014',
  'R0015',
  'R0017',
];

export const ruleIdsType: string[] = ['R0002', 'R0003', 'R0004'];

export const ruleIdsModel: string = 'R0016';

export enum CONSTRUCTION_TYPE {
  STEEL = '001',
}
